import { apiShortUrl } from './api';

apiShortUrl.interceptors.request.use((config) => {
  const tokenParam = {
    params: {
      ...config.params,
      token: process.env.TOKEN_ICLINIC_SHORT_URL_API,
    },
  };
  return Object.assign(config, tokenParam);
});

export default (originalUrl: String) => apiShortUrl.post('links', { url: originalUrl });
